// 页脚 - 复刻 ai-leapx.com 官网页脚样式(深色四栏)
import React from 'react';

const css = `
.lxf{background:#0f0e0b;color:#c2c3da;padding:60px 48px 32px;width:100%;}
.lxf-inner{max-width:1160px;margin:0 auto;display:grid;grid-template-columns:2.2fr 1fr 1fr 1fr;gap:48px 40px;padding-bottom:40px;border-bottom:1px solid rgba(255,255,255,0.06);}
.lxf-brand{display:flex;align-items:center;gap:9px;margin-bottom:14px;}
.lxf-brand img{width:28px;height:28px;border-radius:7px;background:#1a1b2e;box-shadow:0 2px 8px rgba(0,0,0,0.3);}
.lxf-brand span{font-size:17px;font-weight:800;color:#fff;letter-spacing:-0.02em;}
.lxf-desc{font-size:13px;color:#5a5b78;line-height:1.72;max-width:240px;margin:0;}
.lxf-col h4{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:#3d3e58;margin:0 0 16px;}
.lxf-col a{display:block;font-size:13px;color:#5a5b78;padding:4px 0;text-decoration:none;transition:color .15s;}
.lxf-col a:hover{color:#c2c3da;}
.lxf-bottom{max-width:1160px;margin:24px auto 0;display:flex;justify-content:space-between;align-items:center;font-size:12px;color:#2e2f45;}
@media (max-width:900px){.lxf-inner{grid-template-columns:1fr 1fr;gap:28px 16px;}}
@media (max-width:600px){.lxf{padding:44px 16px 24px;}.lxf-inner{grid-template-columns:1fr 1fr;}.lxf-bottom{flex-direction:column;gap:6px;text-align:center;}}
`;

const Footer = () => (
  <footer className="lxf">
    <style>{css}</style>
    <div className="lxf-inner">
      <div>
        <div className="lxf-brand">
          <img src="https://ai-leapx.com/logos/leapx-icon-128.png" alt="" width="28" height="28" />
          <span>LeapX Hub</span>
        </div>
        <p className="lxf-desc">
          All-in-One API Gateway For LLMs.
          <br />
          更低价格，更高可用，零厂商锁定。
        </p>
      </div>
      <div className="lxf-col">
        <h4>产品</h4>
        <a href="/pricing/">价格方案</a>
        <a href="/panel/playground">模型体验</a>
        <a href="/docs/">开发文档</a>
      </div>
      <div className="lxf-col">
        <h4>公司</h4>
        <a href="https://ai-leapx.com" target="_blank" rel="noopener noreferrer">LeapX 官网</a>
        <a href="https://ai-leapx.com/contact.html" target="_blank" rel="noopener noreferrer">联系我们</a>
      </div>
      <div className="lxf-col">
        <h4>法律</h4>
        <a href="https://hub.ai-leapx.com/privacy.html" target="_blank" rel="noopener noreferrer">隐私政策</a>
        <a href="https://hub.ai-leapx.com/terms.html" target="_blank" rel="noopener noreferrer">服务条款</a>
        <a href="https://hub.ai-leapx.com/refund.html" target="_blank" rel="noopener noreferrer">退款政策</a>
        <a href="https://hub.ai-leapx.com/cancellation.html" target="_blank" rel="noopener noreferrer">取消政策</a>
      </div>
    </div>
    <div className="lxf-bottom">
      <span>© 2026 LeapX Hub. All rights reserved.</span>
      <span>Hong Kong</span>
    </div>
  </footer>
);

export default Footer;
